// Charge la base commune
require('./common.js')

// Styles librairies

// Styles custom
import './scss/pages/credit-simulators'

// Scripts librairies
import 'script-loader!./js/libs/misc.js'

// Components
async function getSimulatorMonthly($f) {
  pageLoading()
  const { default: _ } = await import('lodash')
  import('./js/components/simulator-monthly-form.js').then(module => {
    pageLoading(false)
  })
}

async function getSimulatorCapacity($f) {
  pageLoading()
  const { default: _ } = await import('lodash')
  import('./js/components/simulator-loan-capacity-form.js').then(module => {
    pageLoading(false)
  })
}

async function getSimulatorBorrowing($f) {
  pageLoading()
  const { default: _ } = await import('lodash')
  import('./js/components/simulator-borrowing-amount-form.js').then(module => {
    pageLoading(false)
  })
}

async function getSimulatorDebt($f) {
  pageLoading()
  const { default: _ } = await import('lodash')
  import('./js/components/simulator-debt-ratio-form.js').then(module => {
    pageLoading(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function() {
  if ( $('#wdyw').length ) {
    var target = $('#wdyw')
    $('html, body').animate({
      scrollTop: ($(target).offset().top - 124) - -1
    }, 500)
  }

  if ( $('#monthly').length )
    getSimulatorMonthly()

  if ( $('#capacity').length )
    getSimulatorCapacity()

  if ( $('#borrowing').length )
    getSimulatorBorrowing()

  if ( $('#debt').length )
    getSimulatorDebt()
})
